import payData_store from './components/payData.js'

export default{
    menu:payData_store,
}


// WEBPACK FOOTER //
// ./src/store/modules.js